export default __webpack_public_path__ + "static/proMedCS-49eeef67b43269b782573ae94c4da1a1.svg";